import React, {useCallback, useEffect, useState} from 'react';
import {Dropdown, Button} from "semantic-ui-react";
import './styles.scss';
import {apiPost} from "../../services/apiClient";
import {getCurrentUserCompanyId} from "../../services/userRights";
import {toast} from "react-toastify";
import throttle from 'lodash.throttle';

const RecipientDropdown = (
    {
        className,
        name,
        value,
        recipientUserId,
        disabled,
        onChange,
        placeholder,
        searchErrorText,
        error,
        onEditUser,
        canEditUsers
    }
) => {
    const [options, setOptions] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [counter, setCounter] = useState(0);
    const companyId = getCurrentUserCompanyId();

    useEffect(() => {
        if (!options.length) setCounter(counter+1);
        else setCounter(0);
    }, [options]);

    useEffect(() => {
        if (counter === 5 && searchErrorText) {
            toast.error(searchErrorText);
            setCounter(0);
        }
    }, [counter]);

    const searchDataFunc = (text) => {
        if (!companyId) return;

        apiPost('parcels/ref/users/search', { 
            companyId: companyId, 
            searchText: text || '' // Пустой поиск вернет всех пользователей
        }).then(data => {
            const serverItems = (data.entries || []).map(user => ({
                key: user.id,
                value: user.id,
                text: user.fullName,
                data: { 
                    recipientUserId: user.id,
                    recipientName: user.fullName
                }
            }));
            
            setOptions(serverItems);
            setCounter(0);
        }).catch((e) => {
            console.log('Ошибка поиска получателей:', e);
            setOptions([]);
        });
    };

    const searchData = useCallback(throttle(searchDataFunc, 600), [companyId]);

    const onChangeValue = (e, {value, options}) => {
        if (!value) {
            // Если значение пустое (крестик нажат), очищаем оба поля
            onChange('recipientUserId', null);
            onChange('recipientName', '');
            setSearchQuery('');
            return;
        }
        
        const selectedUser = options.find(opt => opt.value === value);
        if (selectedUser && selectedUser.data) {
            onChange('recipientUserId', value);
            onChange('recipientName', selectedUser.text);
        }
    };

    useEffect(() => {
        setSearchQuery(value || '');
        // Если есть значение, загружаем данные для отображения
        if (value && !options.length) {
            searchData('');
        }
    }, [value]);

    useEffect(() => {
        if (searchQuery && searchQuery !== '') {
            searchData(searchQuery);
        }
    }, [searchQuery]);

    // Загружаем начальные данные при фокусе, если нет поискового запроса
    const handleFocus = () => {
        if (!searchQuery || searchQuery.trim() === '') {
            searchData('');
        }
    };



    return (
        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <div style={{ 
                flex: 1, 
                marginRight: canEditUsers ? '10px' : '0px',
                position: 'relative'
            }}>
                <Dropdown
                    error={error}
                    className={`selection input-dropdown ${canEditUsers ? 'with-edit-button' : ''} ${className || ''}`}
                    placeholder={placeholder}
                    fluid
                    selection
                    name={name}
                    search={() => options}
                    searchQuery={searchQuery}
                    onSearchChange={(e, {searchQuery}) => {
                        setSearchQuery(searchQuery);
                        
                        // Если поисковый запрос пустой, загружаем всех пользователей
                        if (!searchQuery || searchQuery.trim() === '') {
                            searchData('');
                        } else {
                            searchData(searchQuery);
                        }
                    }}
                    onFocus={handleFocus}
                    disabled={disabled}
                    options={options}
                    value={recipientUserId || null}
                    noResultsMessage={'Введите символ для поиска'}
                    onChange={onChangeValue}
                    selectOnNavigation={false}
                    selectOnBlur={false}
                    allowAdditions={false}
                    onBlur={() => {
                        // Восстанавливаем значение только если поисковый запрос пустой
                        if (!searchQuery || searchQuery.trim() === '') {
                            setSearchQuery(value || '');
                        }
                    }}
                    style={{ position: 'relative' }}
                />
                {/* Собственный крестик */}
                {recipientUserId && (
                    <div
                        style={{
                            position: 'absolute',
                            right: '0.5em',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            zIndex: 1000,
                            cursor: 'pointer',
                            color: '#999',
                            fontSize: '18px',
                            fontWeight: '300',
                            width: '20px',
                            height: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: 'transparent',
                            border: 'none',
                            userSelect: 'none'
                        }}
                        onClick={() => {
                            onChange('recipientUserId', null);
                            onChange('recipientName', '');
                            setSearchQuery('');
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.color = '#666';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.color = '#999';
                        }}
                    >
                        ×
                    </div>
                )}
            </div>
            {canEditUsers && (
                <Button
                    type="button"
                    icon="pencil"
                    size="small"
                    onClick={onEditUser}
                    disabled={disabled}
                    title={recipientUserId ? "Редактировать пользователя" : "Создать нового пользователя"}
                    style={{ marginTop: '0px' }}
                />
            )}
        </div>
    );
};

export default RecipientDropdown; 


// WEBPACK FOOTER //
// ./App/components/Dropdowns/RecipientDropdown.jsx